
import { defineComponent } from 'vue';
import { PagePath } from '@/store/application/page.definitions';
import { pageModule } from '@/store/application/page.module';
import { multisidebarModule } from '@/store/multisidebar';
import SettingsMenu from '@/components/common/settings/SettingsMenu.vue';
import PageContentLayout from '../PageContentLayout.vue';

export default defineComponent({
  name: 'SettingsPageLayout',
  components: {
    PageContentLayout,
    SettingsMenu
  },
  computed: {
    sidebarModule() {
      return multisidebarModule;
    }
  },
  methods: {
    updatePageRoute() {
      const pageVM = pageModule.getPageViewModel(this.$route);
      pageVM.state.pagePath = this.$route.path as PagePath;
    }
  },
  activated() {
    this.sidebarModule.contentOverlap = true;
  },
  mounted() {
    this.sidebarModule.contentOverlap = true;
  },
  deactivated() {
    this.sidebarModule.contentOverlap = false;
  },
  beforeUnmount() {
    this.sidebarModule.contentOverlap = false;
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.updatePageRoute();
      }
    }
  }
});
